import * as S from './SupportSection.styled';

export default function SupportSection() {
    return (
        <>
            {' '}
            <S.HideLP>
                <S.SupportSectionContainer>
                    <S.VideoPrompt>
                        Don't take our word for it!{' '}
                        <span style={{ whiteSpace: 'nowrap' }}>Hear what our </span>
                        immigration experts have to say.
                    </S.VideoPrompt>
                    <S.IFrame
                        title="What our experts have to say"
                        src="https://player.vimeo.com/video/853824120?h=b3d357b647&color=ffffff&title=0&byline=0&portrait=0"
                        allow="fullscreen"
                    ></S.IFrame>
                    <S.ChatPrompt>Still have questions? Let's chat!</S.ChatPrompt>
                    {/* <S.WhatsAppButton href="https://api.whatsapp.com/message/PCFUIFSG6HN5E1?autoload=1&app_absent=0">
                        Aliro WhatsApp Support
                        <S.WhatsAppIcon />
                    </S.WhatsAppButton> */}
                    <S.Or>Or</S.Or>
                    <S.EmailContainer>
                        <S.EmailPrompt>Write to us at: </S.EmailPrompt>
                        <S.Mailto href="mailto:support@aliroimmigration.com">
                            support@aliroimmigration.com
                        </S.Mailto>
                    </S.EmailContainer>
                </S.SupportSectionContainer>
            </S.HideLP>
            <S.ShowLP>
                {/* <S.WhatsAppButton href="https://api.whatsapp.com/message/PCFUIFSG6HN5E1?autoload=1&app_absent=0">
                    Aliro Support
                    <S.WhatsAppIcon />
                </S.WhatsAppButton> */}
            </S.ShowLP>
        </>
    );
}
